// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> sky-on-main
// Generated: 2026-11-03T22:58:02.683Z
// Counts: 1 design, 78 content, 52 slot group, 4 collection binding, 8 section, 1 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Your Questions, Answered</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Historic High-Rise Living at Sky on Main</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments in Kansas City, MO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Rooftop Terrace, Fitness Center, Co-Working &amp; More</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply for <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Sky on Main</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Talk With Our Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions About Sky on Main</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1> 1 &amp; 2 Bedroom Downtown Kansas City Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Sky on Main Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Apartment is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Photos of Our Kansas City High Rise Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Picture Yourself in Our Luxury Kansas City Apartments</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments in Downtown Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Surround yourself with Kansas City's best.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Downtown Kansas City Starts at Sky on Main</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Friendly Apartments in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>On-Site Dog Park at Sky on Main</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pay rent and manage your account</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Our Kansas City Luxury Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Plan Your Visit to Sky on Main</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From the Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of Sky on Main</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Our Apartments and Amenity Spaces Online</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to learn more about Sky on Main? Our leasing team is happy to help with <a class=\"richtext-link\" href=\"/floor-plans\">current availability</a>, lease terms, parking, <a class=\"richtext-link\" href=\"/amenities\">amenities</a>, or planning your visit, and to answer the questions that matter most to you. </p><p>Call us, stop by the leasing office, or send a message using the form below. We look forward to sharing more about life at Sky on Main in downtown Kansas City, MO.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Get answers about applying, lease terms, parking, pets, utilities, and resident services at Sky on Main.</p><p>Still have a question? The <a class=\"richtext-link\" href=\"/contact-us\">Sky on Main leasing team</a> is here to help.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Every apartment at Sky on Main pairs open-concept living with finishes that suit a historic high-rise, in one- and two-bedroom floor plans with a variety of top amenities.&nbsp;</p><p>Kitchens feature quartz countertops, custom cabinetry, and premium stainless steel appliances, with waterfall islands in select homes. Wide-plank flooring, vaulted ceilings, and a full-size washer and dryer come standard. Select floor plans add built-in desks, frameless glass showers, and a separate bonus office or den space.&nbsp;</p><p>Compare layouts, square footage, and current availability below. Ready to see a space in person? <a class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour</a> to visit Sky on Main</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxury-finishes-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Sky on Main, a luxury apartment community in downtown Kansas City, offers a unique blend of sophistication and comfort. Each phase of this exquisite property features distinct finishes that cater to a variety of tastes and preferences. Sky on Main ensures that every resident experiences the pinnacle of luxury living. Our attention to detail and commitment to quality are evident in every corner, making Sky on Main the premier choice for those seeking an upscale urban lifestyle in the heart of Kansas City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxury-finishes-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Now Leasing in Downtown KC: Compare Finishes of Phase 1 with the New Phase 2 at Sky on Main</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "luxury-finishes-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Luxury Finishes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Sky on Main starts right outside the front door. Located at 10th and Main Street, our apartments in downtown Kansas City sit beside a dedicated KC Streetcar stop, making it easy to reach the River Market, Crossroads Arts District, Union Station, and Crown Center without the car.</p><p>Downtown living is at its best when you get to know it. The Power &amp; Light District brings T-Mobile Center, B&amp;B Theatres, and Cosentino's Downtown Market close to home, along with spots like Bristol Seafood + Steak, Johnnie's Jazz Bar &amp; Grille, and recordBar. Catch a performance at the Kauffman Center for the Performing Arts, explore First Fridays in the Crossroads, or shop City Market on a weekend morning. Before long, you may find a favorite coffee shop or a familiar face behind the counter.&nbsp;</p><p>When it's time to get outside, Berkley Riverfront Park and Penn Valley Park offer trails and green space. Major employers including University Health Truman Medical Center, Children's Mercy Hospital, and H&amp;R Block are nearby, and I-70, I-35, and I-670 connect you to the rest of the metro.</p><p>Explore the neighborhood map below to find more destinations near Sky on Main.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Located at 10th and Main Street, Sky on Main has a dedicated KC Streetcar stop right outside the building. It connects you to the Power &amp; Light District, River Market, Crossroads Arts District, and Union Station. T-Mobile Center, Cosentino's Downtown Market, and the Kansas City Public Library are close by.</p><p>For anyone looking for luxury apartments in downtown Kansas City, it’s hard to beat having the city this close to home. Head out for a concert, a game, or dinner with friends, then come back to a building that feels like yours. And the more you explore, the more neighbors you’ll recognize along the way.&nbsp;</p><p>Visit our <a class=\"richtext-link\" href=\"/neighborhood\">Neighborhood</a> page to see more of what's nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideal Location </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Life downtown is better with a four-legged friend by your side. Sky on Main residents enjoy an on-site dog park and membership in the Price Brothers Pet Royalty Club, making our pet friendly apartments in Kansas City an easy fit for you and your companion.</p><p>Up to two pets are permitted per apartment. Monthly pet rent is $25 per pet, with a non-refundable pet fee of $300 for one pet or $500 for two pets. Breed restrictions apply.</p><p><a class=\"richtext-link\" href=\"/contact-us\">Reach out to the Sky on Main leasing team</a> for complete pet guidelines, restrictions, fees, and current policy information.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Burns &amp; McDonnell</p></li><li><p>Children's Mercy</p></li><li><p>Garmin</p></li><li><p>Hallmark</p></li><li><p>H&amp;R Block</p></li><li><p>Kansas City Chiefs</p></li><li><p>Kansas City Royals</p></li><li><p>KC Current</p></li><li><p>Kansas City University (KCUMB)</p></li><li><p>KU Medical Center</p></li><li><p>Military</p></li><li><p>Oracle</p></li><li><p>Police Officers</p></li><li><p>Saint Lukes</p></li><li><p>Sporting KC</p></li><li><p>University Health Hospital</p></li><li><p>University of Missouri-Kansas City (UMKC)</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Photos and floor plans only tell part of the story. Schedule a guided tour to explore our Kansas City luxury apartments, step inside <a class=\"richtext-link\" href=\"/floor-plans\">available homes</a>, and take in the views from the Sky Vue Terrace.</p><p>Prefer to explore on your own schedule? Self-guided tours are available or you can <a class=\"richtext-link\" href=\"/virtual-tours\">take a virtual tour</a> anytime before you visit.</p><p>Choose a tour option and time below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Comparing the best Kansas City apartments from afar? Sky on Main virtual tours let you walk through our 1 and 2 bedroom homes and amenity spaces from anywhere.</p><p>Like what you see? <a class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour</a> or <a class=\"richtext-link\" href=\"/floor-plans\">compare floor plans</a> to take the next step.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "accessibility-hero.bg_image": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apply-now-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "fair-housing-hero.bg_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "faq-hero.bg_image": {
    "sourceIndex": 88,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a1846e-fe79-730b-8180-792747470178.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area and kitchen with island, stainless steel appliances, and modern decor."
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 0,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-4990-7131-80d9-664b9cf6f506.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sleek living room with large windows overlooking city skyline, featuring a plush grey sofa and modern dining area."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-135f-7715-b755-132495d03e8e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy bedroom with a king-sized bed, bedside tables, and a piece of abstract art."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18473-64fb-716a-86ba-46e6a28156dc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island, stainless steel appliances, and pendant lights."
      }
    }
  },
  "footer.bg_image": {
    "sourceIndex": 40,
    "fieldOverrides": null
  },
  "footer.contact_us_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18476-34de-711b-b4ee-2d7d136fcccc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Skyline of downtown Kansas City with trees in the foreground"
      }
    }
  },
  "hero.slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a1846e-fe61-71ca-a90d-a545e46ad0a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxurious bedroom with a large bed, city views from the windows, and a dresser with a lamp."
      }
    }
  },
  "hero.slide_2": {
    "sourceIndex": 2,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18473-7565-7131-8df3-3c2d84e7822c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A stylish living room with a green sofa, a gold coffee table, and a large abstract art piece."
      }
    }
  },
  "hero.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18473-64fb-716a-86ba-46e6a28156dc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island, stainless steel appliances, and pendant lights."
      }
    }
  },
  "hero.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18473-4ead-7311-98c7-d156891dcb70.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with a marble-top table and pink chairs, adjacent to a sleek kitchen with stainless steel appliances and an island."
      }
    }
  },
  "hero.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a1846f-0185-7337-ac71-ed48d64e3b74.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with beige sofa, blue accent chair, coffee table, and city views."
      }
    }
  },
  "interactive-map-hero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "luxuryfinishes.compare_bathroom": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b662-04c7-717d-90ef-95133af25415.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with double vanity, toilet, and glass-enclosed shower with blue tile."
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d4df-76db-bea1-ce04521170b1.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a vanity, sink, toilet, and glass-enclosed shower."
      }
    }
  },
  "luxuryfinishes.compare_kitchen": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-ed08-7499-91ff-225f638b6c7d.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island, stainless steel appliances, and pendant lighting."
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b65f-de4a-761b-b860-f9edeb8fad0c.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with island and bar stools."
      }
    }
  },
  "luxuryfinishes.compare_kitchen_detail": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-e174-7456-9c52-64ae9b26c079.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and a deep sink."
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-bd27-75a9-b123-3c9a8ca9357e.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white cabinetry, subway tile backsplash, and large sink."
      }
    }
  },
  "luxuryfinishes.compare_laundry": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a1794a-0390-741c-a047-f652832cd6ba.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Stacked white washer and dryer in a closet with shelving"
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a1794a-0209-75dc-a6af-a1007330fde6.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Stackable washer and dryer in a closet"
      }
    }
  },
  "luxuryfinishes.compare_living": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a17946-9304-718c-a639-7b1ad2d83f46.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with island, sofa, and view of shower."
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a17946-84ef-75a4-81ae-802c1b867512.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Modern apartment living room and kitchen area with a large island and city views."
      }
    }
  },
  "luxuryfinishes.compare_lock": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a1794a-b3a2-7454-b18f-3782b2371faf.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Modern apartment door with brushed nickel handle and lock"
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-fcb4-73bc-b0f2-b3297456363d.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Apartment door with Yale smart lock and brushed nickel handle."
      }
    }
  },
  "luxuryfinishes.compare_shower": {
    "sourceIndex": null,
    "fieldOverrides": {
      "before_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d9f0-7212-be31-9338aa7171c6.webp"
      },
      "before_alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with blue tiled shower and built-in shelves"
      },
      "after_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b661-d84d-749b-92b3-b4d6f12a6b87.webp"
      },
      "after_alt": {
        "type": "VALUE",
        "customValue": "Modern shower stall with white tile and chrome fixtures"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "neighborhoodsection.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18476-364e-735e-9af3-34742c2d2a36.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A tall, ornate tower with blue lights at dusk, with light trails from cars on the street below."
      }
    }
  },
  "neighborhoodsection.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18476-3c31-7737-8439-12b612a1a7e9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor entertainment space with a large screen, seating, and a fountain."
      }
    }
  },
  "neighborhoodsection.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18476-3903-7726-a2eb-9fa733d6573b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kansas City Power & Light District signage on a brick building exterior."
      }
    }
  },
  "neighborhoodsection.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a18476-3448-75d9-88be-78b569b2a05d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Streetcar passing by a grand, historic building at sunset."
      }
    }
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 61,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a130f8-2932-71c5-a324-329d30e2ba09.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A young girl and her terrier share a touching moment in a sunlit field, Burnsville, Minnesota."
      }
    }
  },
  "preferred-employer-hero.bg_image": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "privacy-policy-hero.bg_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "resident-access-hero.bg_image": {
    "sourceIndex": 98,
    "fieldOverrides": null
  },
  "reviews-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167610/01a0b660-1c5b-711e-8d0c-74474b0c4540.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Sky on Main rooftop lounge with modern seating and a fire pit overlooking downtown Kansas City buildings"
      }
    }
  },
  "sister-properties-hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with island and bar stools."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-a4b3-7372-8cca-31f853d7c8cb.webp"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a sunset sky."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-e1e8-732a-b9b1-a99d29387e5f.webp"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex courtyard with a swimming pool, lounge chairs, outdoor seating, and grilling area."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650d-0754-76b9-995f-1ed6bd5038a0.webp"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept living and kitchen area in an apartment with a sofa, coffee table, TV, and kitchen island."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-fc8f-7718-89fb-81c6daee3386.webp"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Sky on Main sister apartment community"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Sky on Main sister apartment community"
      }
    }
  },
  "sitemap-hero.bg_image": {
    "sourceIndex": 37,
    "fieldOverrides": null
  },
  "thank-you-hero.bg_image": {
    "sourceIndex": 40,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "ec_1ec722bd767ac5ce59ab9f31",
      "ec_c59fd0cb398d6b90739836c3",
      "ec_a56751d8de71d71b310a77f9",
      "ec_3cef43982be8ae4e08cefbf8",
      "ec_7a16364071a31efd63260b84",
      "ec_ac5005f49848acf21e66345b",
      "ec_6eaf4672373b639edc54c007",
      "ec_86855f4bc0f3e38ca798a7ff",
      "ec_352ae20250c6bc605e4e7137",
      "ec_abde9b398878461ba3831bf1",
      "ec_4cbb257d485cc5cc5f3b7547",
      "ec_7cd0f8d8be4650f053da0e73",
      "ec_2393d97e501fc22aeed166bd",
      "ec_df0635b9a38b8aefda598ff1",
      "ec_b231a42da328929920b1836e",
      "ec_4692dfc029ebbde40908c9ba",
      "ec_bf78eec45277ce9cd926090b",
      "ec_161fa96bb4c999f8c955f5ec",
      "ec_d4355459f5bb867ffef8a287",
      "ec_273be5587046789628d360c1",
      "ec_e6093a0925dd675d58774def",
      "ec_15998a2aa998aac6084fd7e1",
      "ec_b0b3c1500c753d4a0ebb6752",
      "ec_43122cbc843f3c4038761a4a",
      "ec_13ae7452c9c513915c8da570",
      "ec_a0ea0010b7b46b36d65fa96a",
      "ec_520f940cca2c4f5fc0a34b28",
      "ec_49caa03cf98a7e924913922c",
      "ec_f34e14f581a82e775da0750e",
      "ec_8e4ce01467121e4633bc3341",
      "ec_b1cb714296f86c27d37d2bc0",
      "ec_481cce8c02c13d45bfe54bbe",
      "ec_43b01e4250ffae73505578fa",
      "ec_c18b170fb48e12ef99cb6aa9",
      "ec_5a9b3455a3fbc2d024a0f96e",
      "ec_bdc3b023160378f7f69c0bec",
      "ec_8adf3476b2530b4aec6cb5b4",
      "ec_776cd33f26587afa0bde937e",
      "ec_1af55fc2054b4ba61725948e",
      "ec_43a5e1dd571560649a481536",
      "ec_e6788bb3e94c09566ee6abae",
      "ec_9e160a9aef8b1d5a7932ec78",
      "ec_82e52674c65ba625b7099106",
      "ec_3475d2c54c8f5380ac9c1374",
      "ec_f3509a839eadc37eef291542",
      "ec_3b922ce974f1c68e7c5a222d",
      "ec_1edbc2724835f73934509a44",
      "ec_f7b1de0b001d408005613efd",
      "ec_912f1eea3badf6cf05a0fbe7",
      "ec_fb47c01cac675834da72cf2b",
      "ec_8c980fbaac550813167b063e",
      "ec_2095032dfdae6bfba794b822",
      "ec_3664fb1b8743c120063a40d3",
      "ec_2a1aa0a9ef7df2db0dda0888",
      "ec_0438ce31be380db968e4735d",
      "ec_b1496d81230f4cc5516a3442",
      "ec_0d0dda5ab2901fa7b5f336b1",
      "ec_8b91ea9d1e0adb581e93e7ad",
      "ec_6e54ad6a764b10a577abaf39",
      "ec_168d0fc4e206e310d3dd9103",
      "ec_4e0ccbffca6e7c90c1f11a50",
      "ec_38339cce6a0c66af1a469949",
      "ec_1a2781f49998c23bf93bdb99",
      "ec_5941937e88381020858f165f",
      "ec_63dbbbeae0a591774b1ee517",
      "ec_1a7b11e15d59bff7b439bf9a",
      "ec_56f21ae953ffd17493da24da",
      "ec_b87bcc676315e878be62044a",
      "ec_5db6761a8033549c323506fa",
      "ec_f5294787421e85008270c85a",
      "ec_1f5219d056298a5018adf2a6",
      "ec_e64c2bae8f43dbffb05c4f76",
      "ec_43fcdc473aba5def78ffaacf",
      "ec_02d488f1814f290ce4c70531",
      "ec_7aa30c10e681134fe5faf09b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": 12,
    "hiddenIds": null,
    "orderedIds": [
      "ec_e5e1034fed783b244332b160",
      "ec_d5289457eb8223a3b007ccf4",
      "ec_85707baaa3458c8cadee3be7",
      "ec_6d73ea3e026437f29f7c763d",
      "ec_3bed10695bea33ed8f7b8a97",
      "ec_0021f24b00f5e526e39e8b76",
      "ec_067a9be209da310ca1d8519c",
      "ec_21c283480ba9268e2797ecdb",
      "ec_bbea676a28c5265b9def2e1f",
      "ec_fe19ff1b934b9ca4fd353a70",
      "ec_e971349ccc45797aae882186",
      "ec_0214d28cda3a9528df78c52b",
      "ec_acb9d30b7064e814452a4d9c",
      "ec_453e8eb07d81ab843347593c",
      "ec_85c76394368e77dabdf2df99",
      "ec_b3695a121ecb6a4fef320378",
      "ec_b0e8847552454cecfbc26da6",
      "ec_3873eac204fc4dc3710df74e",
      "ec_1ab5cafeeb446f627efaf9f2",
      "ec_bc5aeafb5397da8cf4f52645",
      "ec_0d30a09d922dc27fc828a4d0",
      "ec_b2a46ddb4253207f14898118",
      "ec_3982afbc2929bd2379218c0f",
      "ec_ee97981d05490ebeb98fe825",
      "ec_950fc36fa479af4cb3709fc6",
      "ec_c75f56501f6bc6942208b904",
      "ec_756663bffc98c9c5836e32af",
      "ec_7ea8c226063a3d04c0df0f0e",
      "ec_9034a8de63cdcb797b2cbadf",
      "ec_5d5e82515cc0675355f3696a",
      "ec_b622c93781acb3a61479aa27",
      "ec_398d8f32e16f54fc867707dc",
      "ec_1ec62987e1dfc2b0a3e20d86",
      "ec_d89da8cf29c0467c56cbbe3c",
      "ec_78c5a195de8ed6c4297c06f9",
      "ec_0d1dafbe66039ad547153cbe",
      "ec_da1f9ac50b96d656199ff0c9",
      "ec_d53b83f197a49cc44e1aa5f8",
      "ec_2c262ccc475527eddadb417c",
      "ec_de36a72ab87de3b85363e1b0",
      "ec_ed79067fbfcb371ae0662116",
      "ec_c918343ae53f57a98958fa09",
      "ec_d824bd50b862506c1fb0570a",
      "ec_06fa999445c2c161adcecf7c",
      "ec_8a23d926c0e9049208afcafb",
      "ec_6da0ea428a1ebd6adea5f624",
      "ec_3aa27a4f0038b68bf7840b0b",
      "ec_78bf941cb96dacef34598689",
      "ec_0f1c4b0746cccd2b84f2c916",
      "ec_33f4ba43b31e2e64e8bfdc9f",
      "ec_6436cba38c1c34bfea6377c5",
      "ec_1dc5c99451ad7edb0a364209",
      "ec_bcddc94707f97dd5f94f7b53",
      "ec_e6eb058d3c4c8485d48c4906",
      "ec_bf7a25915f9a20e0e0f9fbf1",
      "ec_deb92baf19cb700d4a2aabef",
      "ec_21ffbb372a3721aefcac2ac4",
      "ec_4384ffda70c966c36a34651d",
      "ec_fdf147bd0f39650478c9b7a8",
      "ec_2c12abe6d0b4180b2ca9b899",
      "ec_ab98de1484ac3df92a31460b",
      "ec_8d3282de88e18b7e00b9265d",
      "ec_f38f960617672dfcf7c2f292",
      "ec_f2297e6cded127bffe47a0a0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": 14,
    "hiddenIds": null,
    "orderedIds": [
      "ec_843e084afaab37c512441083",
      "ec_98283b86fbf1199f9c613b4b",
      "ec_d7d2d55f829c99d9f424c398",
      "ec_25259f85efc7666280dc2eee",
      "ec_70b51d9824abd5db6974e221",
      "ec_f92496771bb78c856dc6eb27",
      "ec_d3fb0da3c80e3c1dad984079",
      "ec_b3096b68bee6b8c0785a84ca",
      "ec_e6c6e7cd73ccd096a09b97e3",
      "ec_8afb145ad5aa70392194ad53",
      "ec_b3d37fc4fd549ed22559ac0b",
      "ec_f9fcc4659c6d815bce6bf9d9",
      "ec_9327385b399bc76b8e075a1a",
      "ec_b4697cb8d84c159bb37d91ed",
      "ec_0f34681007d56edcef8f93e5",
      "ec_28d96ba94f0e6180e16ed7b3",
      "ec_f81036b2e6232514b4e6fb18",
      "ec_b9320d64b1bbead3e88d0a7e",
      "ec_4262ba5daa89bfba0ba79209",
      "ec_25bab51c83a4c8977d4b6c8b",
      "ec_90d4b6c3068d6937332501d7",
      "ec_f2104d7c3e3632648861dde4",
      "ec_7f3051e882999656f706f467",
      "ec_32aa7673d1dfa06d227c38f1",
      "ec_1e5c2f29a8acba573c6ace59",
      "ec_00a680c4b3908ccdd9e98db4",
      "ec_df9f026cc057c70991c0b4ea",
      "ec_9343ea1765d523e3e5aaac52",
      "ec_f0c36f79f680016403fe63f7",
      "ec_c0dfe6d12d02387522e6d587",
      "ec_55cf39e25f68a5f3349e8db2",
      "ec_d5bbe0502f6990dc38873131",
      "ec_1d183ee6d787b94913b92967",
      "ec_202a4af3709152eaebd4619a",
      "ec_f446808aa38f1dd615bd09ec",
      "ec_ec4bc0d8b2764797093753c0",
      "ec_5b76c787883c8bbfeeb1c330",
      "ec_b319c8c91a933e502cb3c895",
      "ec_30f88588c1874b220c3bf5cb",
      "ec_378432031263c8d48a7d31a6"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_0f34681007d56edcef8f93e5"
    ],
    "orderedIds": [
      "ec_9327385b399bc76b8e075a1a",
      "ec_d3fb0da3c80e3c1dad984079",
      "ec_e971349ccc45797aae882186",
      "ec_8afb145ad5aa70392194ad53",
      "ec_0021f24b00f5e526e39e8b76",
      "ec_b3096b68bee6b8c0785a84ca",
      "ec_f81036b2e6232514b4e6fb18",
      "ec_25259f85efc7666280dc2eee",
      "ec_b9320d64b1bbead3e88d0a7e",
      "ec_f92496771bb78c856dc6eb27",
      "ec_0f34681007d56edcef8f93e5",
      "ec_98283b86fbf1199f9c613b4b",
      "ec_70b51d9824abd5db6974e221",
      "ec_4262ba5daa89bfba0ba79209",
      "ec_25bab51c83a4c8977d4b6c8b",
      "ec_90d4b6c3068d6937332501d7",
      "ec_f2104d7c3e3632648861dde4",
      "ec_d7d2d55f829c99d9f424c398",
      "ec_e6c6e7cd73ccd096a09b97e3",
      "ec_7f3051e882999656f706f467",
      "ec_32aa7673d1dfa06d227c38f1",
      "ec_b093eb1dec5d782aa90b26ea",
      "ec_f9fcc4659c6d815bce6bf9d9",
      "ec_b319c8c91a933e502cb3c895",
      "ec_9343ea1765d523e3e5aaac52",
      "ec_b3d37fc4fd549ed22559ac0b",
      "ec_f0c36f79f680016403fe63f7",
      "ec_d5bbe0502f6990dc38873131",
      "ec_55cf39e25f68a5f3349e8db2",
      "ec_843e084afaab37c512441083",
      "ec_c0dfe6d12d02387522e6d587",
      "ec_31fe7a3ec217c17213505467",
      "ec_1d183ee6d787b94913b92967",
      "ec_5b76c787883c8bbfeeb1c330",
      "ec_b4697cb8d84c159bb37d91ed",
      "ec_f446808aa38f1dd615bd09ec",
      "ec_ec4bc0d8b2764797093753c0",
      "ec_28d96ba94f0e6180e16ed7b3",
      "ec_df9f026cc057c70991c0b4ea",
      "ec_00a680c4b3908ccdd9e98db4",
      "ec_30f88588c1874b220c3bf5cb",
      "ec_202a4af3709152eaebd4619a",
      "ec_378432031263c8d48a7d31a6",
      "ec_1e5c2f29a8acba573c6ace59",
      "ec_85c76394368e77dabdf2df99",
      "ec_b622c93781acb3a61479aa27",
      "ec_6d73ea3e026437f29f7c763d",
      "ec_453e8eb07d81ab843347593c",
      "ec_0d1dafbe66039ad547153cbe",
      "ec_7ea8c226063a3d04c0df0f0e",
      "ec_78bf941cb96dacef34598689",
      "ec_2c262ccc475527eddadb417c",
      "ec_d53b83f197a49cc44e1aa5f8",
      "ec_de36a72ab87de3b85363e1b0",
      "ec_6da0ea428a1ebd6adea5f624",
      "ec_3aa27a4f0038b68bf7840b0b",
      "ec_bf7a25915f9a20e0e0f9fbf1",
      "ec_e6eb058d3c4c8485d48c4906",
      "ec_e5e1034fed783b244332b160",
      "ec_1dc5c99451ad7edb0a364209",
      "ec_85707baaa3458c8cadee3be7",
      "ec_deb92baf19cb700d4a2aabef",
      "ec_21ffbb372a3721aefcac2ac4",
      "ec_bc5aeafb5397da8cf4f52645",
      "ec_950fc36fa479af4cb3709fc6",
      "ec_3873eac204fc4dc3710df74e",
      "ec_d5289457eb8223a3b007ccf4",
      "ec_acb9d30b7064e814452a4d9c",
      "ec_0214d28cda3a9528df78c52b",
      "ec_3982afbc2929bd2379218c0f",
      "ec_9034a8de63cdcb797b2cbadf",
      "ec_4384ffda70c966c36a34651d",
      "ec_d89da8cf29c0467c56cbbe3c",
      "ec_b0e8847552454cecfbc26da6",
      "ec_bbea676a28c5265b9def2e1f",
      "ec_b3695a121ecb6a4fef320378",
      "ec_b2a46ddb4253207f14898118",
      "ec_3bed10695bea33ed8f7b8a97",
      "ec_756663bffc98c9c5836e32af",
      "ec_ee97981d05490ebeb98fe825",
      "ec_fdf147bd0f39650478c9b7a8",
      "ec_2c12abe6d0b4180b2ca9b899",
      "ec_8d3282de88e18b7e00b9265d",
      "ec_f38f960617672dfcf7c2f292",
      "ec_5d5e82515cc0675355f3696a",
      "ec_398d8f32e16f54fc867707dc",
      "ec_78c5a195de8ed6c4297c06f9",
      "ec_ed79067fbfcb371ae0662116",
      "ec_d824bd50b862506c1fb0570a",
      "ec_ab98de1484ac3df92a31460b",
      "ec_1ec62987e1dfc2b0a3e20d86",
      "ec_bcddc94707f97dd5f94f7b53",
      "ec_da1f9ac50b96d656199ff0c9",
      "ec_f2297e6cded127bffe47a0a0",
      "ec_0d30a09d922dc27fc828a4d0",
      "ec_21c283480ba9268e2797ecdb",
      "ec_06fa999445c2c161adcecf7c",
      "ec_8a23d926c0e9049208afcafb",
      "ec_fe19ff1b934b9ca4fd353a70",
      "ec_c75f56501f6bc6942208b904",
      "ec_c918343ae53f57a98958fa09",
      "ec_0f1c4b0746cccd2b84f2c916",
      "ec_33f4ba43b31e2e64e8bfdc9f",
      "ec_067a9be209da310ca1d8519c",
      "ec_1ab5cafeeb446f627efaf9f2",
      "ec_6436cba38c1c34bfea6377c5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
